import React from 'react';
import classNames from 'classnames';
import { useLocation, useParams } from 'react-router-dom';
import { useQuery } from 'react-apollo';
import qs from 'query-string';

import FullScreenLoader from '../../../../../components/global/FullScreenLoader';
import { MeWithRosterQrCodes } from '../../../../../graphql/queries/account';
import { AlbumFolderForRosterQrCodes } from '../../../../../graphql/queries/album-folder';
import RosterQrCodesPrintItem from './components/RosterQrCodesPrintItem';

const DEFAULT_LIMIT = 999;

const RosterQrCodesPrint = () => {
  const { albumFolderId } = useParams();
  const location = useLocation();

  const { offset, limit } = qs.parse(location.search ?? '');

  const { data: { me } = {}, loading: loadingRosterQrCodes } = useQuery(
    MeWithRosterQrCodes,
    {
      variables: {
        album_folder_id: albumFolderId,
        offset: offset ? parseInt(offset, 10) : undefined,
        limit: limit ? parseInt(limit, 10) : DEFAULT_LIMIT,
      },
    },
  );
  const { data: { albumFolder } = {}, loading: loadingAlbumFolder } = useQuery(
    AlbumFolderForRosterQrCodes,
    {
      variables: {
        id: albumFolderId,
      },
    },
  );

  if (loadingRosterQrCodes || loadingAlbumFolder || !me || !albumFolder) {
    return <FullScreenLoader />;
  }

  const rosterQrCodes = me?.roster_qr_codes?.records || [];
  const itemsPerPage =
    albumFolder?.roster_qr_code_settings?.items_per_page || 1;
  const flyerText = albumFolder?.roster_qr_code_settings?.flyer_text;
  const logoImage = albumFolder?.logo_image || albumFolder?.account?.logo_image;

  const pages = Array.from(
    { length: Math.ceil(rosterQrCodes.length / itemsPerPage) },
    (_, pageIndex) =>
      rosterQrCodes.slice(
        pageIndex * itemsPerPage,
        (pageIndex + 1) * itemsPerPage,
      ),
  );

  const classes = classNames({
    'roster-qr-codes-print': true,
    landscape: itemsPerPage === 2,
  });

  return (
    <div id={`roster-qr-codes-print-${albumFolderId}`} className={classes}>
      {pages.map((pageRosterQrCodes, pageIndex) => (
        <div
          key={pageIndex}
          className={`roster-qr-codes-print-page items-per-page-${itemsPerPage}`}
        >
          {pageRosterQrCodes.map(rosterQrCode => (
            <RosterQrCodesPrintItem
              key={rosterQrCode.id}
              rosterQrCode={rosterQrCode}
              logoImage={logoImage}
              flyerText={flyerText}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default RosterQrCodesPrint;
